import { AxiosProgressEvent } from "axios";

import { fetcher } from "helpers/fetcher";

import { TUploadJobListingImageReq, TUploadJobListingImageRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const uploadJobListingImage = async (
  payload: TUploadJobListingImageReq,
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
) => {
  return await fetcher<
    TUploadJobListingImageRes,
    TUploadJobListingImageReq["data"]
  >(ENDPOINT.CORPORATION.UPLOAD_JOB_LISTING_IMAGE, {
    data: payload.data,
    fileFields: ["image"],
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.UPLOAD_JOB_LISTING_IMAGE.version,
      [API_HEADER.CORP_ID]: payload.idCorp,
    },
    onUploadProgress: (progressEvent) => {
      if (onUploadProgress) onUploadProgress(progressEvent);
    },
  });
};
